module.exports = __webpack_public_path__ + "img/clone.bb901443.jpg";